import React, { useContext, useEffect, useRef, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom";
import './FixedBottom.scss'
import { SortFilter } from "../filters/SortFilter"
import { MainContext } from "../../Contexts/MainContext";

export function FixedBottom({
    isSticky = false,
    sortOptions,
    sortOption,
    onSortChange,
    hasActiveFilters = false,
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const { setFilterOverlayOpen } = useContext(MainContext) || {};
    const [selected, setSelected] = useState(0);
    const ref = useRef(null);
    const useCustomSort = Array.isArray(sortOptions) && typeof onSortChange === 'function';
    const sortApplied = useCustomSort && sortOption && sortOption !== 'popularity';
    const stripPriceLabel = (label) => (label || '').replace(/^Price:\s*/i, '');
    const currentSortLabel = useCustomSort && sortOption
        ? stripPriceLabel(sortOptions.find((o) => o.value === sortOption)?.label)
        : 'SORT';

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setSelected(0);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [ref]);

    const handleSortSelect = (value) => {
        onSortChange(value);
        setSelected(0);
    };

    const openFilter = () => {
        setSelected(0);
        if (setFilterOverlayOpen) {
            setFilterOverlayOpen(true);
        } else {
            navigate('/filter', { state: { from: location.pathname, scrollY: window.scrollY } });
        }
    };

    return (
        <>
            {selected === 0 ? (
                <div className="grid sticky proportionalDivisionView" style={isSticky ? { position: 'sticky' } : null}>
                    <div className="column_1_2">
                        <div className="ripple-container">
                            <button type="button" className="btn default btn primary flat results-btn" onClick={() => setSelected(1)}>
                                <svg width="24" height="24" viewBox="0 0 24 24" className="result-icon">
                                    <g fill="currentColor" fillRule="evenodd">
                                        <path d="M0 0h24v24H0z" opacity="0.05" />
                                        <path fill="currentColor" d="M7.445 7.48V5.672L5.665 7.48h1.78zm1.09-4.42c.304.12.465.39.465.706v16.437a.784.784 0 01-.783.797.762.762 0 01-.772-.781V8.982H4.003a.832.832 0 01-.765-.204.759.759 0 01.002-1.105L7.652 3.23a.832.832 0 01.882-.17zm8.02 15.269l1.78-1.81h-1.78v1.81zm4.207-3.107a.76.76 0 01-.002 1.106l-4.412 4.442a.832.832 0 01-.882.17c-.305-.12-.466-.39-.466-.706V3.797c0-.432.332-.797.783-.797.45 0 .772.35.772.781v11.237h3.442a.833.833 0 01.765.204z" />
                                    </g>
                                </svg>
                                {sortApplied ? currentSortLabel : 'SORT'}
                            </button>
                            <div className="ripple" />
                        </div>
                    </div>
                    <div className="buttonDivider" />
                    <div className="column_1_2">
                        <div className="ripple-container">
                            <button type="button" className={`btn default btn primary flat results-btn ${hasActiveFilters ? 'filter-applied' : ''}`} onClick={openFilter}>
                                <svg width="24" height="24" viewBox="0 0 24 24" className="result-icon">
                                    <g fill="currentColor" fillRule="evenodd">
                                        <path d="M0 0h24v24H0z" opacity="0.05" />
                                        <path fill="currentColor" d="M3.749 7.508a.75.75 0 010-1.5h3.138a2.247 2.247 0 014.243 0h9.121a.75.75 0 010 1.5h-9.126a2.248 2.248 0 01-4.232 0H3.749zm13.373 9h3.129a.75.75 0 010 1.5h-3.135a2.247 2.247 0 01-4.231 0H3.749a.75.75 0 010-1.5h9.13a2.248 2.248 0 014.243 0z" />
                                    </g>
                                </svg>
                                FILTER{hasActiveFilters ? ' ✓' : ''}
                            </button>
                            <div className="ripple" />
                        </div>
                    </div>
                </div>
            ) : selected === 1 ? (
                useCustomSort ? (
                    <div ref={ref} className="fixed-bottom-with-panel">
                        <div className="fixed-bottom-sort-panel fixed-bottom-sort-panel-opens-up">
                            <ul className="fixed-bottom-sort-list" role="listbox">
                                {sortOptions.map((opt) => (
                                    <li
                                        key={opt.value}
                                        role="option"
                                        aria-selected={sortOption === opt.value}
                                        className={sortOption === opt.value ? 'selected' : ''}
                                        onClick={() => handleSortSelect(opt.value)}
                                    >
                                        <span>{stripPriceLabel(opt.label)}</span>
                                        {sortOption === opt.value && <span className="fixed-bottom-sort-check">✓</span>}
                                    </li>
                                ))}
                            </ul>
                            {/* <div className="fixed-bottom-sort-header">
                                <button type="button" className="fixed-bottom-sort-back" onClick={() => setSelected(0)} aria-label="Close">×</button>
                            </div> */}
                        </div>
                        <div className="grid sticky proportionalDivisionView" style={isSticky ? { position: 'sticky' } : null}>
                            <div className="column_1_2">
                                <div className="ripple-container">
                                    <button type="button" className="btn default btn primary flat results-btn" onClick={() => setSelected(0)}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" className="result-icon">
                                            <g fill="currentColor" fillRule="evenodd">
                                                <path d="M0 0h24v24H0z" opacity="0.05" />
                                                <path fill="currentColor" d="M7.445 7.48V5.672L5.665 7.48h1.78zm1.09-4.42c.304.12.465.39.465.706v16.437a.784.784 0 01-.783.797.762.762 0 01-.772-.781V8.982H4.003a.832.832 0 01-.765-.204.759.759 0 01.002-1.105L7.652 3.23a.832.832 0 01.882-.17zm8.02 15.269l1.78-1.81h-1.78v1.81zm4.207-3.107a.76.76 0 01-.002 1.106l-4.412 4.442a.832.832 0 01-.882.17c-.305-.12-.466-.39-.466-.706V3.797c0-.432.332-.797.783-.797.45 0 .772.35.772.781v11.237h3.442a.833.833 0 01.765.204z" />
                                            </g>
                                        </svg>
                                        {sortApplied ? currentSortLabel : 'SORT'}
                                    </button>
                                    <div className="ripple" />
                                </div>
                            </div>
                            <div className="buttonDivider" />
                            <div className="column_1_2">
                                <div className="ripple-container">
                                    <button type="button" className={`btn default btn primary flat results-btn ${hasActiveFilters ? 'filter-applied' : ''}`} onClick={openFilter}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" className="result-icon">
                                            <g fill="currentColor" fillRule="evenodd">
                                                <path d="M0 0h24v24H0z" opacity="0.05" />
                                                <path fill="currentColor" d="M3.749 7.508a.75.75 0 010-1.5h3.138a2.247 2.247 0 014.243 0h9.121a.75.75 0 010 1.5h-9.126a2.248 2.248 0 01-4.232 0H3.749zm13.373 9h3.129a.75.75 0 010 1.5h-3.135a2.247 2.247 0 01-4.231 0H3.749a.75.75 0 010-1.5h9.13a2.248 2.248 0 014.243 0z" />
                                            </g>
                                        </svg>
                                        FILTER{hasActiveFilters ? ' ✓' : ''}
                                    </button>
                                    <div className="ripple" />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div ref={ref}>
                        <SortFilter setSelected={setSelected} />
                    </div>
                )
            ) : null}
        </>
    );
}